import ContactBubbles from './ContactBubbles'

export default ContactBubbles



// WEBPACK FOOTER //
// ./src/components/shared/elements/ContactBubbles/index.js